import { lCache } from '@/helpers/log';
import { load, save } from './storage';
import moment from 'moment';
import { event } from 'vue-analytics';

const CACHE_KEY = 'data_cache';
let globalCache: any = load(CACHE_KEY, () => ({}));
const debounceBusy: any = {};
const noCache = !!localStorage.getItem('nocache');
// on load, clean cache
(() => {
  const currentTs = moment().unix();
  const toDel = [];
  for (const key in globalCache) {
    if (!globalCache.hasOwnProperty(key)) { continue; }
    if (globalCache[key].expiry < currentTs) {
      toDel.push(key);
    } else {
      setTimeout(() => del(key), (globalCache[key].expiry - currentTs) * 1000);
    }
  }
  for (const key of toDel) {
    delete globalCache[key];
  }
  save(CACHE_KEY, globalCache);
})();

function set(key: any, expiry: number, data: any) {
  lCache('*SET', key);
  event('cache', 'set', key);

  globalCache[key] = { data, expiry: moment().unix() + expiry };
  setTimeout(() => del(key), expiry * 1000);
  save(CACHE_KEY, globalCache);
}

function del(key: any) {
  lCache('-DEL', key);
  event('cache', 'del', key);

  delete globalCache[key];
  save(CACHE_KEY, globalCache);
}

async function cache(key: any, expiry: number, cb: any) {
  // key = await hash(JSON.stringify(key))
  if (!noCache && globalCache[key]) {
    lCache('+HIT', key);
    event('cache', 'hit', key);

    await wait(200);
    return globalCache[key].data;
  }

  // dedup multiple calls with same caching key
  if (debounceBusy[key]) {
    const waitFnc = new Promise((resolve, reject) => {
      debounceBusy[key].push({ resolve, reject });
    });
    return await waitFnc;
  }

  debounceBusy[key] = [];
  try {
    lCache('*MIS', key);
    event('cache', 'mis', key);

    const data = await cb();
    for (const ob of debounceBusy[key]) {
      ob.resolve(data);
    }

    delete debounceBusy[key];
    if (data) {
      set(key, expiry, data);
      return data;
    }
  } catch (err) {
    for (const ob of debounceBusy[key]) {
      ob.reject(err);
    }

    delete debounceBusy[key];
    throw err;
  }
}

async function clearCache(){
  lCache('*CLEAR', 'ALL');

  globalCache = {  };
  save(CACHE_KEY, globalCache);
}

const w: any = window;

function textEncode(str: string) {
  if (w.TextEncoder) {
    return new w.TextEncoder('utf-8').encode(str);
  }
  const utf8 = unescape(encodeURIComponent(str));
  const result = new Uint8Array(utf8.length);
  for (let i = 0; i < utf8.length; i++) {
    result[i] = utf8.charCodeAt(i);
  }
  return result;
}

// const cryp = w.crypto || w.msCrypto;
// function hash(str: string) {
//   // worst case, return full string
//   if ((!cryp) || (!cryp.digest)) { return str; }

//   function hex(buffer: any) {
//     const hexCodes = [];
//     const view = new DataView(buffer);
//     for (let i = 0; i < view.byteLength; i += 4) {
//       const value = view.getUint32(i);
//       const stringValue = value.toString(16);
//       const padding = '00000000';
//       const paddedValue = (padding + stringValue).slice(-padding.length);
//       hexCodes.push(paddedValue);
//     }
//     return hexCodes.join('');
//   }
//   const buffer = textEncode(str);
//   const res = cryp.subtle.digest('SHA-256', buffer);
//   if (res.then) {
//     return res.then(function(hash: any) {
//       return hex(hash);
//     });
//   } else if (res.result) {    // IE11
//     return {
//       then(resolver: any) {
//         resolver(hex(res.result));
//       },
//     };
//   }
// }

function wait(val: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, val);
  });
}

export default cache;
export {
  del,
  set,
  clearCache
};
